// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__upQfL","footer":"ModalCreateQualiphyProcedure_footer__2syqt","additionData":"ModalCreateQualiphyProcedure_additionData__2ws4O"};